import styleInject from 'style-inject';

var css_248z = ".TableCell-module_cell__mGqlG{border-bottom:1px solid var(--color-neutral);font-size:var(--size--1);padding:var(--space-xs)}";
var styles = {"cell":"TableCell-module_cell__mGqlG"};
styleInject(css_248z);

export { styles as default };
//# sourceMappingURL=data:application/json;charset=utf-8;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoiVGFibGVDZWxsLm1vZHVsZS5zY3NzLmpzIiwic291cmNlcyI6W10sInNvdXJjZXNDb250ZW50IjpbXSwibmFtZXMiOltdLCJtYXBwaW5ncyI6Ijs7Ozs7Ozs7In0=
